/* global I18n  */

import {Controller} from "@hotwired/stimulus"

class RecaptchaController extends Controller {
  static targets = ["container"]

  connect() {
    window.addEventListener(
      "turnstile-loaded",
      this.render_recaptcha.bind(this)
    )
    if (window.turnstile) {
      window.dispatchEvent(new CustomEvent("turnstile-loaded"))
    }
  }

  disconnect() {
    window.removeEventListener("turnstile-loaded", this.render_recaptcha)
  }

  render_recaptcha() {
    if (window.gon.can_bypass_recaptcha) return

    window.turnstile.render(this.containerTarget, {
      callback: this.on_success.bind(this),
      "error-callback": this.on_error.bind(this),
      "expired-callback": this.on_error.bind(this)
    })
  }

  on_success() {
    this.dispatch("success")
  }

  on_error() {
    window.dispatchEvent(new CustomEvent("toast:add", {
      detail: {
        title: I18n.t("js.recaptcha_error.title"),
        subtitle: I18n.t("js.recaptcha_error.subtitle_html"),
        type: "alert",
        duration: false
      }
    }))
    this.dispatch("failure")
  }

  get_controller(el, name) {
    return this.application.getControllerForElementAndIdentifier(el, name)
  }
}


export default RecaptchaController
